import React from 'react';

import { useFormBuilderContext } from 'lib/context/FormBuilder/FormBuilderContext';

import Button from 'components/shared/Button/Button';

const FooterButtons = ({
  buttonText,
  nextTo,
  backTo,
  showSaveAndExit = false,
  isLastStep,
  setBreadCrumbs,
  showSkip
}) => {
  const {
    enableNextTo,
    formik,
    handleClose,
    showNavigationButtons,
    isEdit,
    setIsSaveAndExit,
    selectedLength
  } = useFormBuilderContext();
  const navigateViews = ({ componentToView = '', isNext = false }) => {
    setBreadCrumbs((prevCrumbs) =>
      prevCrumbs.map((crumb) => {
        if (crumb.view === componentToView) {
          return { ...crumb, active: true, hidden: false };
        } else if (isNext && crumb.active && !crumb.isFinished) {
          return { ...crumb, isFinished: true, active: false };
        } else {
          return { ...crumb, active: false };
        }
      })
    );
  };
  const handleSubmit = (hasSaveAndExit) => {
    if (hasSaveAndExit) {
      setIsSaveAndExit(true);
    }
    formik.handleSubmit();
  };
  return (
    <div className="flex w-full items-center justify-end gap-3">
      {showNavigationButtons ? (
        <Button
          isDisabled={!backTo}
          style="outlined"
          color="neutral"
          text="Back"
          onClick={() => navigateViews({ componentToView: backTo })}
          data-qa="back-btn"
        />
      ) : (
        <Button
          color="neutral"
          text="Close"
          style="outlined"
          onClick={handleClose}
          data-qa="close-btn"
        />
      )}
      <div className="flex-end flex gap-3">
        {showSaveAndExit && (
          <Button
            text="Save & exit"
            onClick={() => handleSubmit(true)}
            style="outlined"
            data-qa="save-exit-btn"
          />
        )}

        {showNavigationButtons && nextTo && (
          <Button
            isDisabled={!enableNextTo}
            text={buttonText}
            onClick={() => navigateViews({ componentToView: nextTo, isNext: true })}
            data-qa={`${buttonText}-btn`}
          />
        )}
        {showSkip && <Button text="Skip" onClick={() => handleSubmit()} style="outlined" />}
        {isLastStep && (
          <Button
            text={isEdit ? 'Update' : 'Add'}
            isDisabled={isEdit ? false : !selectedLength}
            onClick={handleSubmit}
            data-qa="submit-btn"
          />
        )}
      </div>
    </div>
  );
};

export default FooterButtons;
